import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { aboutData } from '@/mocks/articles';
import { useJsonLd } from '@/hooks/useJsonLd';

export default function AboutPage() {
  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "首页",
        "item": "http://ahyuntong.cn/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "关于我们"
      }
    ]
  };

  const webPageSchema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": `关于${aboutData.brandName} - 品牌介绍与联系方式`,
    "description": `${aboutData.brandName}是国内领先的娱乐资讯聚合平台，覆盖网红塌房、明星爆料、博主反差等热点内容。了解我们的品牌故事与联系方式。`,
    "url": "http://ahyuntong.cn/about",
    "inLanguage": "zh-CN",
    "isPartOf": {
      "@type": "WebSite",
      "name": "51吃瓜黑料",
      "url": "http://ahyuntong.cn/"
    }
  };

  useJsonLd(breadcrumbSchema);
  useJsonLd(webPageSchema);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative w-full h-[380px] md:h-[480px] overflow-hidden">
          <div className="absolute inset-0 bg-foreground-950"></div>
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
          <div className="relative z-10 w-full h-full flex items-center">
            <div className="w-full px-4 md:px-6">
              <div className="max-w-7xl mx-auto">
                <nav className="flex items-center gap-2 text-sm mb-6" aria-label="面包屑导航">
                  <Link to="/" className="text-background-50/60 hover:text-background-50 transition-colors">首页</Link>
                  <span className="text-background-50/40">/</span>
                  <span className="text-background-50">关于我们</span>
                </nav>
                <h1 className="font-heading text-3xl md:text-5xl font-bold text-background-50 mb-3">
                  关于 {aboutData.brandName}
                </h1>
                <p className="text-background-50/70 text-sm md:text-base max-w-xl">
                  {aboutData.tagline} · 爆料不打烊 · 网址入口导航
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-50">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="flex flex-col lg:flex-row gap-10 items-center">
                <div className="w-full lg:w-1/2">
                  <div className="rounded-2xl overflow-hidden bg-background-100">
                    <img
                      src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20modern%20office%20or%20creative%20workspace%20with%20soft%20amber%20and%20cream%20lighting%2C%20minimalist%20editorial%20style%2C%20clean%20simple%20composition%2C%20professional%20yet%20warm%20atmosphere%2C%20no%20people%2C%20abstract%20aesthetic&width=800&height=800&seq=about-brand&orientation=squarish"
                      alt="51吃瓜黑料品牌形象"
                      title="51吃瓜黑料 - 全网最全吃瓜平台"
                      className="w-full object-cover object-top"
                    />
                  </div>
                </div>
                <div className="w-full lg:w-1/2">
                  <div className="inline-flex items-center px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-medium mb-6">
                    品牌理念
                  </div>
                  <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
                    致力打造全网
                    <br />
                    最全吃瓜平台
                  </h2>
                  <div className="text-foreground-600 text-sm md:text-base leading-relaxed space-y-4">
                    <p>{aboutData.description1}</p>
                    <p>{aboutData.description2}</p>
                    <p>{aboutData.description3}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 bg-primary-500">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {aboutData.stats.map((stat) => (
                  <div key={stat.label} className="text-center">
                    <p className="font-heading text-3xl md:text-4xl font-bold text-background-50 mb-1">{stat.value}</p>
                    <p className="text-background-50/70 text-xs md:text-sm">{stat.label}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 bg-background-100">
          <div className="px-4 md:px-6">
            <div className="max-w-7xl mx-auto">
              <div className="mb-10">
                <p className="text-foreground-500 font-label text-xs tracking-wider uppercase mb-2">
                  我们的优势
                </p>
                <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-tight">
                  为什么选择
                  <br />
                  <span className="text-foreground-400">51吃瓜黑料</span>
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {aboutData.advantages.map((adv) => (
                  <div
                    key={adv.title}
                    className="bg-background-50 rounded-lg p-6 transition-all duration-300 hover:bg-accent-50"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-background-100 mb-5">
                      <i className={`${adv.icon} text-xl text-foreground-700`}></i>
                    </div>
                    <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2">
                      {adv.title}
                    </h3>
                    <p className="text-foreground-600 text-xs md:text-sm leading-relaxed">
                      {adv.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section id="contact">
          <div className="flex flex-col lg:flex-row">
            <div className="w-full lg:w-1/2 relative h-[350px] md:h-[500px] overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20toned%20abstract%20digital%20art%20of%20modern%20communication%20concept%2C%20amber%20and%20cream%20gradients%2C%20minimalist%20design%2C%20clean%20editorial%20style%2C%20soft%20atmosphere&width=800&height=1000&seq=about-contact-left&orientation=portrait"
                alt="侵权申诉与联系"
                title="51吃瓜黑料 侵权申诉与联系"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8">
                <p className="font-heading text-2xl md:text-4xl font-bold text-background-50 leading-tight">
                  侵权申诉
                  <br />
                  与联系
                </p>
              </div>
            </div>
            <div className="w-full lg:w-1/2 bg-background-50 flex items-center justify-center py-14 md:py-20 px-8 md:px-16">
              <div className="max-w-md text-center">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6 leading-tight">
                  商务合作
                  <br />
                  与删帖申请
                </h2>
                <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
                  如有商务合作需求或涉及侵权申诉，请通过以下方式联系我们。我们将在24小时内回复您的诉求，确保每一位用户的合法权益得到保障。
                </p>
                <div className="flex flex-col gap-3">
                  <div className="flex items-center justify-center gap-3 text-foreground-600 text-sm">
                    <i className="ri-mail-line"></i>
                    <span>hello@ahyuntong.cn</span>
                  </div>
                  <div className="flex items-center justify-center gap-3 text-foreground-600 text-sm">
                    <i className="ri-phone-line"></i>
                    <span>400-888-8888</span>
                  </div>
                  <div className="flex items-center justify-center gap-3 text-foreground-600 text-sm">
                    <i className="ri-map-pin-line"></i>
                    <span>北京市朝阳区XX路XX号</span>
                  </div>
                </div>
                <a
                  href="mailto:hello@ahyuntong.cn"
                  className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-medium text-sm whitespace-nowrap hover:bg-primary-600 transition-colors duration-200 mt-8"
                >
                  发送邮件
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}